export const data = [{
    "id": 0,
    "quantity": 4,
    "price": "71.99",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jh4m0w84o7jhpt8a1vhk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jh4m0w84o7jhpt8a1vhk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jh4m0w84o7jhpt8a1vhk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jh4m0w84o7jhpt8a1vhk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jh4m0w84o7jhpt8a1vhk.jpg"
    ],
    "name": "id eiusmod",
    "description": "Et ut ipsum dolore nostrud dolore cupidatat. Fugiat id mollit commodo cillum deserunt fugiat commodo magna nisi culpa laborum aliqua elit. Elit labore commodo dolor sint fugiat excepteur quis laborum non.",
    "ratings": [
    3,
    4,
    3,
    5,
    4,
    2,
    0,
    1,
    4,
    2
    ],
    "reviews": [
    {
        "user": "Josephine Jefferson",
        "review": "Cillum laboris officia elit veniam amet adipisicing est proident sit aliquip fugiat cillum occaecat ea. Duis esse officia eu adipisicing magna."
    },
    {
        "user": "Sheryl Cox",
        "review": "Excepteur amet minim sunt culpa cupidatat. In duis eu consectetur occaecat."
    },
    {
        "user": "Flynn Munoz",
        "review": "Cillum amet fugiat cillum ad pariatur laborum id. Id excepteur cillum occaecat mollit pariatur veniam non."
    },
    {
        "user": "Mcneil Wyatt",
        "review": "Eiusmod aute mollit exercitation fugiat dolor aute duis adipisicing nisi anim quis esse. Eiusmod culpa fugiat id officia do commodo labore culpa in exercitation ex."
    },
    {
        "user": "Leonor Bridges",
        "review": "Adipisicing in irure qui Lorem sunt cupidatat ut mollit. Pariatur est est pariatur nulla enim voluptate ea ea dolore ut."
    }
    ],
    "color": "violet"
},
{
    "id": 1,
    "quantity": 9,
    "price": "29.39",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/milbmv86aluigur6o7xq.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/milbmv86aluigur6o7xq.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/milbmv86aluigur6o7xq.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/milbmv86aluigur6o7xq.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/milbmv86aluigur6o7xq.jpg"
    ],
    "name": "qui irure",
    "description": "Ullamco reprehenderit ad laborum occaecat quis tempor mollit voluptate est fugiat. Magna occaecat ex qui in commodo ea pariatur laboris sit sunt nisi anim excepteur. Proident consequat qui laboris amet consectetur nisi fugiat aliquip qui Lorem aliqua. Ullamco laboris laboris non sunt deserunt proident tempor do reprehenderit do ut et dolor. Dolor culpa mollit enim ipsum laborum. Occaecat officia elit nisi cupidatat elit do. Culpa dolore cillum Lorem sit irure laborum.",
    "ratings": [
    0,
    5,
    2,
    2,
    5,
    2,
    4,
    5,
    2,
    1
    ],
    "reviews": [
    {
        "user": "Maryanne Finch",
        "review": "Ea commodo proident aliqua incididunt Lorem eiusmod esse mollit amet. Esse adipisicing magna reprehenderit laborum."
    },
    {
        "user": "Gonzalez Fitzgerald",
        "review": "Lorem anim irure dolore nulla cupidatat. Enim ullamco aliquip ullamco cillum eiusmod quis sint in."
    },
    {
        "user": "Kelsey Bush",
        "review": "Sunt nostrud ad aliquip esse. Adipisicing commodo officia est aute anim."
    },
    {
        "user": "Chambers Weber",
        "review": "Ea occaecat ex dolore ad ut enim irure. Non labore sint ipsum deserunt exercitation esse ea ea in anim fugiat dolore sunt voluptate."
    },
    {
        "user": "Nanette Schwartz",
        "review": "Ad irure magna fugiat tempor sit et ea consectetur ea sunt aliqua aliqua anim quis. Proident sunt magna deserunt excepteur."
    }
    ],
    "color": "green"
},
{
    "id": 2,
    "quantity": 8,
    "price": "79.59",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/glcfdoefif0v94eyhvl6.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/glcfdoefif0v94eyhvl6.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/glcfdoefif0v94eyhvl6.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/glcfdoefif0v94eyhvl6.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/glcfdoefif0v94eyhvl6.jpg"
    ],
    "name": "ullamco sit",
    "description": "Pariatur ea irure dolor irure dolore nostrud veniam. Lorem officia anim aliqua veniam nisi cupidatat. Lorem et excepteur pariatur ipsum consequat amet aliqua et.",
    "ratings": [
    0,
    3,
    4,
    4,
    0,
    2,
    1,
    0,
    5,
    0
    ],
    "reviews": [
    {
        "user": "Katina Riggs",
        "review": "Excepteur quis anim cillum id consequat Lorem eiusmod nulla eiusmod nisi eu aliquip ullamco et. Ad commodo mollit ullamco Lorem esse."
    },
    {
        "user": "Dorothea Bright",
        "review": "Ullamco id nostrud occaecat aliquip fugiat et incididunt nostrud nisi ex dolor minim sint. Exercitation qui magna consectetur minim."
    },
    {
        "user": "Clarke Collins",
        "review": "Incididunt aliquip ullamco amet commodo. Ad enim quis deserunt cillum adipisicing nulla aliqua aliquip ex est."
    },
    {
        "user": "Booker Dunlap",
        "review": "Lorem sint enim occaecat in nulla Lorem do commodo quis minim nulla aute. Id sint quis pariatur amet commodo sunt esse aute aliqua amet pariatur."
    },
    {
        "user": "Page Cooley",
        "review": "Cupidatat exercitation eu nisi in elit magna. Et excepteur aute do incididunt voluptate consectetur voluptate duis fugiat deserunt enim proident."
    }
    ],
    "color": "blue"
},
{
    "id": 3,
    "quantity": 1,
    "price": "81.69",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hcyckhtwdkxzzyazztfh.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hcyckhtwdkxzzyazztfh.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hcyckhtwdkxzzyazztfh.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hcyckhtwdkxzzyazztfh.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hcyckhtwdkxzzyazztfh.jpg"
    ],
    "name": "velit ex",
    "description": "Enim elit esse ex fugiat eiusmod veniam excepteur non. Veniam duis adipisicing cupidatat incididunt nisi. Irure do sint ipsum minim cillum elit cillum voluptate et sit pariatur. Ullamco cupidatat officia pariatur reprehenderit irure eu laboris minim eu ea occaecat incididunt amet. Ea occaecat consectetur consectetur nulla proident qui nulla non ut esse Lorem fugiat. Incididunt nulla duis do excepteur eiusmod deserunt aliquip cupidatat. Velit incididunt nulla id veniam sint officia ullamco.",
    "ratings": [
    4,
    3,
    0,
    5,
    3,
    3,
    5,
    1,
    4,
    0
    ],
    "reviews": [
    {
        "user": "Cox Spears",
        "review": "Aute nisi quis nisi aute nulla non deserunt excepteur et velit culpa deserunt. Mollit ea ullamco tempor proident consectetur incididunt occaecat."
    },
    {
        "user": "Latasha Snow",
        "review": "Reprehenderit sunt sunt consequat anim aliquip reprehenderit labore amet amet qui et et nostrud aliquip. Reprehenderit nulla anim excepteur dolor veniam proident veniam."
    },
    {
        "user": "Morgan Kirkland",
        "review": "Irure et esse nisi culpa do ad deserunt. Ex ipsum eu mollit anim in."
    },
    {
        "user": "Robles Hoover",
        "review": "Dolor do in irure do ea labore et cillum ea voluptate pariatur. Do culpa sint pariatur non."
    },
    {
        "user": "Jodi Lowery",
        "review": "Fugiat occaecat reprehenderit consequat sit quis nulla reprehenderit ad adipisicing pariatur. Tempor minim sunt exercitation labore adipisicing proident do laborum dolor minim quis sunt."
    }
    ],
    "color": "green"
},
{
    "id": 4,
    "quantity": 5,
    "price": "78.44",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/m6s5cihgr9ycykio3519.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/m6s5cihgr9ycykio3519.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/m6s5cihgr9ycykio3519.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/m6s5cihgr9ycykio3519.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/m6s5cihgr9ycykio3519.jpg",
    ],
    "name": "in enim",
    "description": "Ullamco consequat magna veniam magna esse. Ipsum adipisicing eiusmod adipisicing laborum sunt non commodo enim ipsum aute proident irure eiusmod minim. Esse anim adipisicing reprehenderit est exercitation incididunt ea culpa est aute. Minim ea aute aute sit in sint id aliqua ipsum ex reprehenderit enim.",
    "ratings": [
    2,
    2,
    5,
    0,
    4,
    2,
    4,
    3,
    4,
    3
    ],
    "reviews": [
    {
        "user": "Owen Donovan",
        "review": "Ex officia incididunt anim aliquip amet excepteur aute non. Ad ullamco ad irure dolor pariatur occaecat consequat aliqua labore ea nisi."
    },
    {
        "user": "Scott Mcdaniel",
        "review": "Sint sint nulla ad exercitation reprehenderit sint officia. Deserunt est veniam incididunt magna minim ullamco Lorem nostrud laboris et reprehenderit est proident."
    },
    {
        "user": "Sheena Nelson",
        "review": "Enim tempor voluptate deserunt commodo. Nostrud aliqua occaecat aliquip minim non ut."
    },
    {
        "user": "Sonia Shannon",
        "review": "Incididunt aute est pariatur velit velit quis culpa enim amet duis. Nostrud ea do reprehenderit eu non eu et consectetur id irure voluptate sint mollit."
    },
    {
        "user": "Tabitha Miles",
        "review": "Commodo qui est esse veniam. Eu non aute enim non."
    }
    ],
    "color": "white"
},
{
    "id": 5,
    "quantity": 8,
    "price": "51.04",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gilchckrrdi3fppnuipv.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gilchckrrdi3fppnuipv.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gilchckrrdi3fppnuipv.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gilchckrrdi3fppnuipv.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gilchckrrdi3fppnuipv.jpg",
    ],
    "name": "aliquip duis",
    "description": "Occaecat veniam minim nulla aliquip eiusmod. Non adipisicing ad consequat in. Amet ex labore ut commodo ut fugiat eu ipsum mollit. Velit incididunt qui labore aliqua est dolore commodo minim sunt. Dolor dolor quis labore proident non deserunt in. Incididunt commodo nulla eiusmod ut. Amet nisi dolore dolore labore laborum aliqua.",
    "ratings": [
    0,
    3,
    2,
    4,
    5,
    5,
    4,
    2,
    1,
    5
    ],
    "reviews": [
    {
        "user": "Ester Cole",
        "review": "Occaecat officia officia quis aute culpa adipisicing sunt irure reprehenderit velit eiusmod sint. Lorem quis duis cillum ullamco cillum laboris ut adipisicing elit officia qui."
    },
    {
        "user": "Acevedo Gay",
        "review": "Consequat dolore aliquip anim irure. Veniam exercitation deserunt sint commodo."
    },
    {
        "user": "Karin Cervantes",
        "review": "Elit esse elit anim eiusmod consequat tempor esse proident aute incididunt ea incididunt nostrud officia. Magna elit minim qui aliquip aliqua non reprehenderit commodo est voluptate veniam Lorem amet reprehenderit."
    },
    {
        "user": "Carter Cherry",
        "review": "Ipsum tempor cillum ad id irure dolore labore voluptate occaecat pariatur labore eu. Minim labore ipsum aliquip nostrud tempor adipisicing culpa proident laborum mollit do in cupidatat."
    },
    {
        "user": "Antonia Curtis",
        "review": "Commodo sit laboris nisi minim. Consequat Lorem velit anim amet ipsum aliqua labore fugiat incididunt nulla in nostrud dolore esse."
    }
    ],
    "color": "white"
},
{
    "id": 6,
    "quantity": 7,
    "price": "80.16",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/k9afqvcms6rtzhtwpybk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/k9afqvcms6rtzhtwpybk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/k9afqvcms6rtzhtwpybk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/k9afqvcms6rtzhtwpybk.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/k9afqvcms6rtzhtwpybk.jpg",
    ],
    "name": "consectetur quis",
    "description": "Consequat et nulla anim consequat. Officia sunt elit elit pariatur et aliqua eu aliquip aute consectetur cupidatat et voluptate. Labore id esse adipisicing quis aute commodo cillum officia. Est esse in minim mollit aliquip adipisicing esse aliqua. Incididunt aliqua ipsum fugiat mollit officia voluptate dolor aliquip laboris irure et laborum consectetur reprehenderit. Dolore qui cillum non adipisicing non deserunt eiusmod dolor id ut adipisicing. Magna incididunt cillum consectetur aliqua et in minim tempor elit aliquip incididunt non aute deserunt.",
    "ratings": [
    2,
    1,
    5,
    0,
    3,
    0,
    4,
    1,
    2,
    4
    ],
    "reviews": [
    {
        "user": "Tasha Parrish",
        "review": "Deserunt cillum cupidatat adipisicing fugiat minim quis ullamco est sint fugiat dolor exercitation nostrud. Nisi nisi magna sint cillum ipsum anim."
    },
    {
        "user": "Marylou Sweeney",
        "review": "Id pariatur ea quis pariatur pariatur sint nulla ipsum pariatur dolor duis proident commodo. Do est nostrud ipsum enim dolore non nisi minim."
    },
    {
        "user": "Bates Cain",
        "review": "Tempor dolore laboris duis occaecat et nostrud. Deserunt mollit adipisicing non amet non ea ullamco magna in pariatur nisi laborum reprehenderit."
    },
    {
        "user": "Liliana Mccall",
        "review": "Dolore minim anim irure adipisicing id occaecat incididunt. Proident aliquip non veniam anim occaecat minim."
    },
    {
        "user": "Fanny Owens",
        "review": "Aute aliquip est incididunt amet laborum pariatur ipsum culpa. Exercitation et veniam cupidatat labore."
    }
    ],
    "color": "violet"
},
{
    "id": 7,
    "quantity": 9,
    "price": "50.88",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jzafzzqlrjvelktlvih9.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jzafzzqlrjvelktlvih9.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jzafzzqlrjvelktlvih9.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jzafzzqlrjvelktlvih9.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/jzafzzqlrjvelktlvih9.jpg",
    ],
    "name": "ex nisi",
    "description": "Nisi nostrud do dolor laboris Lorem cupidatat reprehenderit do. Consequat est enim veniam exercitation sint dolor ut. Occaecat cillum velit ea consectetur irure esse.",
    "ratings": [
    0,
    5,
    2,
    1,
    2,
    3,
    2,
    4,
    4,
    5
    ],
    "reviews": [
    {
        "user": "Shannon Velez",
        "review": "Non consequat voluptate mollit dolore. Aute cillum dolor eiusmod deserunt aliqua aute proident ea dolor duis ea anim officia."
    },
    {
        "user": "French Rosario",
        "review": "Laborum officia elit cillum officia aute exercitation quis sunt dolor excepteur sint. Tempor minim elit enim proident magna anim id dolor."
    },
    {
        "user": "Kelley Holloway",
        "review": "Voluptate consequat labore in cupidatat commodo cillum ea aliquip anim. Velit cillum aliqua nulla eu officia mollit mollit sunt deserunt fugiat aliqua consequat excepteur non."
    },
    {
        "user": "Emma Guthrie",
        "review": "Officia minim sit aliqua laborum ullamco cillum officia sint ut nostrud amet. Quis quis proident voluptate fugiat sint tempor ullamco."
    },
    {
        "user": "Helga Tyler",
        "review": "Tempor eiusmod eiusmod non et esse dolore. Id Lorem est tempor quis pariatur dolor aliqua amet esse esse quis ullamco."
    }
    ],
    "color": "indigo"
},
{
    "id": 8,
    "quantity": 8,
    "price": "14.13",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gzjiqlhwuhkynnaxsaa2.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gzjiqlhwuhkynnaxsaa2.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gzjiqlhwuhkynnaxsaa2.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gzjiqlhwuhkynnaxsaa2.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/gzjiqlhwuhkynnaxsaa2.jpg",
    ],
    "name": "adipisicing reprehenderit",
    "description": "Lorem in deserunt consequat officia commodo exercitation. Elit reprehenderit quis minim proident voluptate aliqua ullamco reprehenderit ullamco qui occaecat occaecat proident velit. Cupidatat ad sint eu veniam do mollit. Tempor elit id dolore officia magna tempor exercitation irure. Ut excepteur occaecat dolor nostrud in aliquip amet qui adipisicing. Sit esse quis deserunt et enim ad aliquip do nulla eiusmod.",
    "ratings": [
    5,
    0,
    4,
    0,
    4,
    2,
    1,
    5,
    1,
    3
    ],
    "reviews": [
    {
        "user": "Vinson Walters",
        "review": "Anim labore dolor tempor qui dolor velit et pariatur cillum cupidatat. Occaecat duis aliquip consectetur consectetur."
    },
    {
        "user": "Manuela Sparks",
        "review": "Incididunt esse ex occaecat ut magna enim sit officia adipisicing excepteur in commodo ex eu. Sit ut consequat ullamco qui do est."
    },
    {
        "user": "Ware Mclaughlin",
        "review": "Sint culpa laborum anim aute pariatur occaecat elit ut incididunt labore. Anim est voluptate tempor magna tempor enim amet mollit pariatur nisi cupidatat sit culpa."
    },
    {
        "user": "Luna Johns",
        "review": "Lorem aute labore laborum voluptate ipsum consequat labore culpa adipisicing sint incididunt enim laborum. Laborum mollit eiusmod laborum exercitation aute."
    },
    {
        "user": "Charmaine Tanner",
        "review": "In anim Lorem qui nisi sunt nisi. Quis velit id pariatur dolore in commodo commodo elit labore officia."
    }
    ],
    "color": "white"
},
{
    "id": 9,
    "quantity": 4,
    "price": "80.00",
    "images": [
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/reaiwrepoj4a50ve88rj.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/reaiwrepoj4a50ve88rj.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/reaiwrepoj4a50ve88rj.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/reaiwrepoj4a50ve88rj.jpg",
    "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/reaiwrepoj4a50ve88rj.jpg"
    ],
    "name": "laboris commodo",
    "description": "Laboris commodo velit consectetur ad ex mollit consectetur dolore nulla. Magna exercitation eu in sit labore. Commodo consequat dolor enim dolor non aliqua ad Lorem reprehenderit nisi ullamco commodo Lorem. Ullamco do dolore irure pariatur commodo ad dolore. Cupidatat eiusmod fugiat minim tempor consequat sit. Adipisicing cupidatat reprehenderit nulla laboris eiusmod ut magna in ut non exercitation sit excepteur. Non sint ex occaecat et.",
    "ratings": [
    2,
    1,
    5,
    0,
    5,
    4,
    0,
    1,
    5,
    2
    ],
    "reviews": [
    {
        "user": "Bennett Odonnell",
        "review": "Consequat veniam proident minim labore. Cillum mollit ut eu cupidatat deserunt minim elit laboris anim nulla exercitation."
    },
    {
        "user": "Williamson Key",
        "review": "Quis in proident duis tempor quis duis. Quis in occaecat reprehenderit veniam reprehenderit culpa ea enim Lorem laboris."
    },
    {
        "user": "Lorena Park",
        "review": "Sint proident adipisicing veniam eiusmod esse dolore sint elit fugiat amet minim est est. In cillum duis incididunt ut dolor."
    },
    {
        "user": "Valeria Vang",
        "review": "Duis est Lorem fugiat excepteur magna cupidatat nulla. Amet laboris sint excepteur minim enim non mollit deserunt laborum in occaecat mollit."
    },
    {
        "user": "Merle Casey",
        "review": "Velit enim quis non labore veniam proident esse tempor laboris Lorem mollit fugiat. Aliqua eiusmod ea non eiusmod ad magna duis laborum."
    }],
    "color": "red"
  },
  {
    "id": 10,
    "quantity": 0,
    "price": "45.91",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/qpnikzylyw3w0oveblnm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/qpnikzylyw3w0oveblnm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/qpnikzylyw3w0oveblnm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/qpnikzylyw3w0oveblnm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/qpnikzylyw3w0oveblnm.jpg",
    ],
    "name": "nostrud est",
    "description": "Aliquip tempor reprehenderit ut quis ea sunt ad. Minim fugiat voluptate amet consectetur commodo sit velit incididunt reprehenderit veniam adipisicing et veniam proident. Sit aliqua amet adipisicing ea in dolore laborum. Aliqua nostrud cupidatat aliquip velit cupidatat. Et laborum irure irure cillum esse aliquip incididunt duis id. Qui adipisicing laboris ut esse aliqua velit ut reprehenderit proident anim excepteur. Nulla duis laborum exercitation fugiat magna.",
    "ratings": [
      5,
      5,
      4,
      2,
      1,
      5,
      4,
      5,
      0,
      3
    ],
    "reviews": [
      {
        "user": "Moss Bates",
        "review": "Magna magna esse nisi aliquip eiusmod Lorem ullamco anim magna excepteur excepteur. Aliquip voluptate occaecat aliqua laboris consectetur pariatur excepteur cupidatat id nisi ut."
      },
      {
        "user": "Mallory Allen",
        "review": "Dolor nulla veniam eiusmod dolor culpa dolore enim ad aute consectetur. Enim veniam ipsum laborum officia excepteur ad et et sit consectetur."
      },
      {
        "user": "Ingrid Hinton",
        "review": "Velit irure deserunt adipisicing proident. Qui consequat enim tempor mollit."
      },
      {
        "user": "Steele Mitchell",
        "review": "Officia adipisicing eu magna et aliquip sunt fugiat proident aliqua. Magna reprehenderit reprehenderit deserunt consectetur nostrud exercitation aute incididunt in ea fugiat laboris voluptate amet."
      },
      {
        "user": "Hanson Cox",
        "review": "Aliquip do duis adipisicing nulla ipsum commodo anim duis officia deserunt mollit quis. Ipsum anim fugiat non occaecat eiusmod mollit sint anim culpa eiusmod."
      }
    ],
    "color": "green"
  },
  {
    "id": 11,
    "quantity": 5,
    "price": "12.17",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/ypicbqyrlz3fzb5wmxls.jpg",
    ],
    "name": "excepteur commodo",
    "description": "Voluptate deserunt occaecat sit excepteur fugiat. Sit et cillum do occaecat reprehenderit aliquip magna duis aliquip. Nostrud magna duis ut sit consequat labore deserunt. Deserunt proident ad ex voluptate ipsum enim aliqua sit cupidatat mollit.",
    "ratings": [
      0,
      0,
      0,
      5,
      3,
      3,
      3,
      5,
      1,
      5
    ],
    "reviews": [
      {
        "user": "Decker Davenport",
        "review": "Ullamco sunt occaecat in pariatur. Quis pariatur quis labore dolore duis dolor esse incididunt eiusmod consequat fugiat aute culpa."
      },
      {
        "user": "Eva Joyce",
        "review": "Quis irure irure sint Lorem. Consequat in enim tempor ad eiusmod nostrud voluptate esse deserunt nulla labore ad."
      },
      {
        "user": "Shannon Sweeney",
        "review": "Id ipsum veniam pariatur deserunt eiusmod esse in quis qui nostrud dolor ea. Ullamco reprehenderit ea magna tempor id Lorem ex nostrud dolor anim commodo veniam reprehenderit velit."
      },
      {
        "user": "Kristi Padilla",
        "review": "Quis proident eu consequat sint incididunt pariatur excepteur veniam dolore. Reprehenderit dolor ea dolore officia nisi dolore deserunt veniam ad aliqua nostrud aute nulla."
      },
      {
        "user": "Salinas Cervantes",
        "review": "Excepteur nisi mollit duis exercitation duis minim aliquip qui commodo sunt cupidatat. Ullamco velit do dolor consequat."
      }
    ],
    "color": "green"
  },
  {
    "id": 12,
    "quantity": 7,
    "price": "67.45",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/khpcvfitmp76ghuo8nj4.jpg",
    ],
    "name": "nulla aliquip",
    "description": "Cupidatat aliqua et pariatur eu non id ipsum aliqua. Pariatur consectetur aute aliqua fugiat labore eu in sit amet excepteur cupidatat qui magna. Dolor excepteur dolore voluptate id nisi ipsum aliqua quis occaecat nisi ipsum. Ex elit magna minim occaecat veniam pariatur ad dolore.",
    "ratings": [
      0,
      4,
      2,
      1,
      2,
      5,
      1,
      2,
      0,
      3
    ],
    "reviews": [
      {
        "user": "Lawrence Sharpe",
        "review": "Reprehenderit ullamco voluptate qui adipisicing incididunt sint veniam cupidatat quis. Aliqua eiusmod culpa non incididunt id in officia non."
      },
      {
        "user": "Gina Fitzgerald",
        "review": "Laborum sint minim magna eiusmod. Nisi minim non mollit magna minim sit eiusmod esse ullamco occaecat."
      },
      {
        "user": "Leticia Mckinney",
        "review": "Enim dolor commodo nulla elit magna anim excepteur sint duis dolore deserunt laboris eu. Est minim adipisicing consequat Lorem commodo mollit elit cupidatat incididunt nulla quis nisi et."
      },
      {
        "user": "Haley Mendez",
        "review": "Deserunt officia aliqua enim mollit aliquip tempor aliquip proident deserunt velit. Incididunt veniam exercitation nulla dolor eiusmod aute cillum."
      },
      {
        "user": "Mercedes Buck",
        "review": "Duis reprehenderit elit exercitation enim incididunt nostrud velit ex aute fugiat. Id exercitation Lorem quis id adipisicing labore aliqua."
      }
    ],
    "color": "violet"
  },
  {
    "id": 13,
    "quantity": 2,
    "price": "60.93",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/idhkyurjhibawchi6iiv.jpg",
    ],
    "name": "culpa Lorem",
    "description": "Elit fugiat duis mollit consequat Lorem aliquip consectetur enim ex nulla sint. Minim consectetur nisi voluptate consectetur sunt commodo. Deserunt aliqua laborum veniam ea. Velit duis ut sit aliqua ipsum consectetur.",
    "ratings": [
      1,
      1,
      0,
      2,
      3,
      2,
      4,
      4,
      2,
      4
    ],
    "reviews": [
      {
        "user": "Wade Cardenas",
        "review": "Anim do aliqua non enim ad pariatur Lorem et. Nisi esse do et aliquip exercitation tempor nostrud velit Lorem eu Lorem minim nostrud."
      },
      {
        "user": "Madeleine Leach",
        "review": "Et magna id do irure. Ex consectetur ipsum id non mollit mollit aliqua enim esse id irure cupidatat."
      },
      {
        "user": "Pennington Richards",
        "review": "Consectetur elit minim aliqua non do velit. Aliqua veniam tempor irure ipsum."
      },
      {
        "user": "Frieda Grimes",
        "review": "Qui est incididunt ullamco consectetur sunt deserunt do do cillum. Qui occaecat duis anim cillum voluptate."
      },
      {
        "user": "Magdalena Sandoval",
        "review": "Nisi laborum in commodo aliqua cupidatat minim nulla sunt commodo. Deserunt excepteur ea nostrud sit et ex esse duis fugiat et nisi veniam."
      }
    ],
    "color": "blue"
  },
  {
    "id": 14,
    "quantity": 8,
    "price": "87.17",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/axikcbxbct6kbkmjykzm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/axikcbxbct6kbkmjykzm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/axikcbxbct6kbkmjykzm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/axikcbxbct6kbkmjykzm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/axikcbxbct6kbkmjykzm.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/axikcbxbct6kbkmjykzm.jpg",
    ],
    "name": "aute commodo",
    "description": "Non qui quis ut nulla culpa fugiat adipisicing qui incididunt nulla. Non Lorem ad reprehenderit esse tempor reprehenderit nostrud sint. Esse et laborum cillum quis.",
    "ratings": [
      2,
      3,
      4,
      0,
      1,
      4,
      2,
      2,
      3,
      4
    ],
    "reviews": [
      {
        "user": "Rush Hickman",
        "review": "Sunt sint voluptate commodo veniam commodo eu proident consectetur consequat do proident fugiat deserunt. Do id tempor laboris mollit id aute amet adipisicing dolore occaecat aliqua."
      },
      {
        "user": "Lilian Bolton",
        "review": "Aliquip commodo ea nostrud fugiat ea eu nulla. Ut sint cupidatat fugiat fugiat."
      },
      {
        "user": "Lavonne Meadows",
        "review": "Sit ipsum in elit amet cupidatat elit. Cillum cupidatat ipsum amet commodo labore et officia voluptate irure voluptate excepteur consectetur."
      },
      {
        "user": "Daphne Strickland",
        "review": "Esse ea id proident commodo eiusmod reprehenderit nisi occaecat excepteur est sint eu officia. Qui laboris consequat anim labore do aute do exercitation tempor id occaecat."
      },
      {
        "user": "Briggs Kent",
        "review": "In esse velit id nisi est incididunt ipsum reprehenderit. Culpa nostrud culpa adipisicing ad dolore labore amet ipsum."
      }
    ],
    "color": "indigo"
  },
  {
    "id": 15,
    "quantity": 5,
    "price": "88.99",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/oshus48ouayixgt48xc4.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/oshus48ouayixgt48xc4.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/oshus48ouayixgt48xc4.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/oshus48ouayixgt48xc4.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/oshus48ouayixgt48xc4.jpg"
    ],
    "name": "dolore deserunt",
    "description": "Cillum est occaecat Lorem ipsum do laboris anim veniam occaecat dolore. Incididunt enim nisi ea deserunt ex proident aute commodo pariatur veniam adipisicing voluptate ex. Sit amet ad adipisicing sint pariatur exercitation eu eu aliqua velit. Quis pariatur irure culpa elit sunt esse Lorem laboris nisi aliqua esse nulla et enim.",
    "ratings": [
      0,
      4,
      4,
      5,
      0,
      5,
      5,
      1,
      3,
      3
    ],
    "reviews": [
      {
        "user": "Stein Stanley",
        "review": "Lorem proident ex occaecat et duis Lorem non in dolor officia consequat reprehenderit. Id et labore amet aliquip ipsum sint aliqua officia quis eu sunt incididunt."
      },
      {
        "user": "Margret Olsen",
        "review": "Sint consequat ipsum dolor ut culpa voluptate magna tempor fugiat in labore culpa sit proident. Cillum cupidatat aliqua labore deserunt irure sit enim pariatur ut duis."
      },
      {
        "user": "Joanna Walters",
        "review": "Veniam deserunt incididunt incididunt aute occaecat dolor mollit aute sit dolore anim esse. Reprehenderit excepteur cupidatat aute qui nisi dolor velit nisi officia Lorem tempor sit."
      },
      {
        "user": "Parrish Wong",
        "review": "Aute non incididunt eiusmod deserunt sunt exercitation dolore ipsum velit ullamco ea. Aliqua dolor aliquip enim laboris ipsum ad non cillum non aute est."
      },
      {
        "user": "Lea Lowery",
        "review": "Pariatur mollit ut cupidatat adipisicing consequat in non pariatur dolore aliqua laboris tempor fugiat id. Ea adipisicing labore sunt sunt duis ut."
      }
    ],
    "color": "green"
  },
  {
    "id": 16,
    "quantity": 4,
    "price": "31.07",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/dpjx8yfp0xk4ewviqylb.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/dpjx8yfp0xk4ewviqylb.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/dpjx8yfp0xk4ewviqylb.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/dpjx8yfp0xk4ewviqylb.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/dpjx8yfp0xk4ewviqylb.jpg"
    ],
    "name": "Lorem aliqua",
    "description": "Magna cupidatat reprehenderit dolore elit adipisicing. Enim eu proident quis quis dolor ex qui ad in commodo labore quis excepteur. Duis aliqua dolor sunt consectetur cillum dolore elit cillum proident.",
    "ratings": [
      3,
      4,
      1,
      3,
      0,
      3,
      2,
      5,
      1,
      5
    ],
    "reviews": [
      {
        "user": "Celeste Hogan",
        "review": "Sint ullamco consectetur ad ex nulla reprehenderit enim qui aliqua. Reprehenderit sit cupidatat cillum magna deserunt."
      },
      {
        "user": "Navarro Dalton",
        "review": "Culpa consequat aliquip consequat deserunt. Enim exercitation aliquip aute proident eiusmod occaecat."
      },
      {
        "user": "Clements Golden",
        "review": "Ipsum magna proident ex voluptate reprehenderit. Tempor proident fugiat tempor eu ipsum."
      },
      {
        "user": "Fox Dunn",
        "review": "Sint incididunt ipsum anim cupidatat officia duis ut minim. Labore nulla consectetur officia do enim elit."
      },
      {
        "user": "Molina Trujillo",
        "review": "Mollit cupidatat minim quis non officia ex culpa fugiat veniam adipisicing nisi amet. Ullamco tempor exercitation est enim officia est cillum dolor reprehenderit elit minim minim qui."
      }
    ],
    "color": "violet"
  },
  {
    "id": 17,
    "quantity": 0,
    "price": "80.81",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/if4hwtx07axs4h9mhvqz.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/if4hwtx07axs4h9mhvqz.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/if4hwtx07axs4h9mhvqz.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/if4hwtx07axs4h9mhvqz.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/if4hwtx07axs4h9mhvqz.jpg"
    ],
    "name": "ea nulla",
    "description": "Voluptate cillum elit aute sunt mollit esse mollit eu minim veniam. Anim magna Lorem nulla aliquip consectetur culpa amet culpa. Minim eu deserunt enim ad voluptate. Duis eu incididunt nulla occaecat. Ut amet adipisicing aute elit eu elit consequat consectetur occaecat non minim aute exercitation irure. Aute ut pariatur fugiat sunt amet minim nisi magna eu ut sit. Sint eu exercitation dolore cupidatat irure amet do ut amet ex cupidatat laborum.",
    "ratings": [
      2,
      1,
      3,
      4,
      3,
      2,
      2,
      4,
      2,
      4
    ],
    "reviews": [
      {
        "user": "Sasha Dominguez",
        "review": "Minim deserunt esse dolor deserunt ea ullamco laboris. Irure esse reprehenderit ex pariatur aliquip irure do aute elit occaecat."
      },
      {
        "user": "Ramsey Park",
        "review": "Quis sunt officia aute eiusmod ex eu duis excepteur aute nisi fugiat id nostrud. Dolore mollit proident occaecat esse pariatur pariatur commodo nostrud reprehenderit ut non fugiat aliquip laboris."
      },
      {
        "user": "Mooney Cooper",
        "review": "Laborum commodo laboris magna pariatur qui pariatur et ea do. Et laboris occaecat sit magna duis consequat occaecat laborum eiusmod amet."
      },
      {
        "user": "Jimenez Hayes",
        "review": "Aliqua aliquip eu ea sunt nulla in incididunt. Laborum minim deserunt anim dolore cupidatat quis ex."
      },
      {
        "user": "Alisha Clemons",
        "review": "Dolore ipsum ipsum pariatur amet. Laboris est nisi deserunt in aliquip exercitation aliquip adipisicing duis."
      }
    ],
    "color": "white"
  },
  {
    "id": 18,
    "quantity": 3,
    "price": "15.59",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/mkftk55ap8fucr179jlc.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/mkftk55ap8fucr179jlc.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/mkftk55ap8fucr179jlc.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/mkftk55ap8fucr179jlc.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/mkftk55ap8fucr179jlc.jpg"
    ],
    "name": "et officia",
    "description": "Ut qui occaecat do occaecat minim elit aliqua dolore eiusmod esse in reprehenderit deserunt. Et irure aliqua id ut est incididunt magna eiusmod est aute. Enim officia dolore consequat velit duis labore elit cillum. Deserunt consequat eu cillum enim nisi ut excepteur reprehenderit laboris duis laboris. Duis aliqua quis sit quis esse.",
    "ratings": [
      5,
      3,
      2,
      2,
      3,
      4,
      0,
      4,
      2,
      4
    ],
    "reviews": [
      {
        "user": "Eve Norton",
        "review": "Incididunt labore nulla eu anim est labore culpa eiusmod nulla elit id exercitation. Proident enim proident mollit nisi quis duis velit irure."
      },
      {
        "user": "Hull Willis",
        "review": "Sunt ad reprehenderit nisi ea amet qui deserunt est aliquip non. Ipsum cupidatat ut consequat do ut voluptate ut minim cupidatat sit laboris."
      },
      {
        "user": "Alta Elliott",
        "review": "Magna ex velit sit laborum tempor nulla voluptate minim mollit proident irure ipsum. Excepteur duis fugiat commodo id laborum magna qui id aute culpa dolor anim consequat minim."
      },
      {
        "user": "Holloway Lambert",
        "review": "Eu labore non voluptate deserunt. Deserunt incididunt reprehenderit minim mollit aliquip voluptate occaecat incididunt eu deserunt nisi commodo occaecat."
      },
      {
        "user": "Chaney Rodriguez",
        "review": "Incididunt elit exercitation excepteur ullamco tempor sint fugiat non ut. Laboris ad anim ex dolor veniam voluptate ipsum esse officia ut mollit sunt in."
      }
    ],
    "color": "red"
  },
  {
    "id": 19,
    "quantity": 0,
    "price": "74.75",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/nm9evlgo39dwybf3xjor.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/nm9evlgo39dwybf3xjor.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/nm9evlgo39dwybf3xjor.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/nm9evlgo39dwybf3xjor.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/nm9evlgo39dwybf3xjor.jpg"
    ],
    "name": "eiusmod duis",
    "description": "Mollit ex fugiat cillum magna proident minim ex aliquip. Lorem consectetur officia nulla nisi Lorem consectetur id. Cillum Lorem ad cillum cillum reprehenderit ipsum amet ut aute do duis eiusmod culpa Lorem.",
    "ratings": [
      2,
      0,
      3,
      5,
      5,
      1,
      5,
      1,
      5,
      4
    ],
    "reviews": [
      {
        "user": "Angie Orr",
        "review": "Proident sunt reprehenderit occaecat ea occaecat consequat qui exercitation duis consectetur exercitation culpa. Consequat nostrud cillum ex et nisi do exercitation."
      },
      {
        "user": "Marcella Morrow",
        "review": "Ut non reprehenderit ipsum proident deserunt nostrud do ea fugiat dolore magna duis. Ex duis labore adipisicing sunt eu sunt."
      },
      {
        "user": "Terrie Best",
        "review": "Magna proident minim laboris consequat. Velit exercitation ad cillum velit aute deserunt magna."
      },
      {
        "user": "Adeline Short",
        "review": "Et eiusmod excepteur qui ullamco eiusmod consequat. Officia anim esse nostrud cillum incididunt ex cillum cillum sint amet."
      },
      {
        "user": "Harrington Holcomb",
        "review": "Deserunt nulla magna velit do enim elit non deserunt excepteur non culpa elit exercitation. Proident reprehenderit elit ullamco Lorem."
      }
    ],
    "color": "violet"
  },
  {
    "id": 20,
    "quantity": 8,
    "price": "81.80",
    "images": [
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hemdtpfllr4n4ozykobq.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hemdtpfllr4n4ozykobq.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hemdtpfllr4n4ozykobq.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hemdtpfllr4n4ozykobq.jpg",
      "https://res.cloudinary.com/mayashavin/image/upload/v1554936450/workshop2019/products/hemdtpfllr4n4ozykobq.jpg"
    ],
    "name": "excepteur anim",
    "description": "Commodo aute enim et occaecat excepteur quis voluptate excepteur nostrud reprehenderit esse consequat. Consequat velit elit Lorem do. Est aute aliqua aute consectetur incididunt adipisicing incididunt nostrud. Officia enim sit id consectetur labore culpa cupidatat. Dolor nostrud sit fugiat sint elit exercitation officia.",
    "ratings": [
      4,
      3,
      1,
      2,
      3,
      5,
      3,
      1,
      1,
      0
    ],
    "reviews": [
      {
        "user": "Odom Hensley",
        "review": "Commodo sint occaecat ipsum dolore magna tempor occaecat Lorem amet aute. Qui enim minim cillum anim aute aliquip in anim et cupidatat incididunt anim duis aliquip."
      },
      {
        "user": "Connie Mcdonald",
        "review": "Pariatur adipisicing sint occaecat quis. Occaecat enim mollit voluptate consectetur."
      },
      {
        "user": "Christine Matthews",
        "review": "Lorem est exercitation quis ullamco in incididunt in dolor qui magna consectetur labore est sit. Ad cupidatat ex exercitation ad laborum elit ex ad elit dolor."
      },
      {
        "user": "Brown Weaver",
        "review": "Incididunt voluptate velit culpa cillum enim ipsum sit. Laborum magna dolore excepteur veniam nisi enim veniam minim consectetur sint adipisicing tempor ex."
      },
      {
        "user": "Ellis Moses",
        "review": "Officia ipsum duis ex eu. Anim occaecat tempor do occaecat amet enim cupidatat quis nulla laborum."
      }
    ],
    "color": "orange"
  },
];

export const heroBanners = [
  {
    title: "Smashing Super Mario",
    subtitle: "SUMMER COLLECTION 2019",
    buttonText: "Learn more",
    background: "#efebe9",
    image: "https://res.cloudinary.com/mayashavin/image/upload/v1581977722/workshop2019/SuperMario_running.png",
    class: 'sf-hero-item--position-bg-top-right'
  },
  {
    title: "Summer adventure unlocked with Super Mario",
    buttonText: "Learn more",
    subtitle: "SUMMER COLLECTION 2019",
    class:"sf-hero-item--position-bg-bottom-right sf-hero-item--align-right",
    image: "https://res.cloudinary.com/mayashavin/image/upload/v1581977722/workshop2019/SuperMario_running.png"
  },
  {
    title: "Are you ready for some fun?",
    subtitle: "SUMMER COLLECTION 2019",
    buttonText: "Learn more",
    background: "#fce4ec",
    image: "https://res.cloudinary.com/mayashavin/image/upload/v1581977707/workshop2019/super-mario-png-super-mario-by-mintenndo-d62lh70-png-1147.png",
    class: 'sf-hero-item--position-bg-top-left'
  }
];